import { Box } from "../../box";
import { forwardRef, useMemo } from "react";
import { cssModule, mergeProps, slot, useSlots } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { Text } from "../../typography";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerIllustration({
  as = DefaultElement,
  children,
  forwardedRef,
  orientation = "horizontal",
  shape = "straight",
  ...rest
}) {
  const orientationValue = useResponsiveValue(orientation);
  const {
    content,
    heading,
    image
  } = useSlots(children, useMemo(() => ({
    _: {
      required: ["image"]
    },
    content: {
      as: Text,
      className: "o-ui-illustration-content"
    },
    heading: {
      as: "h3",
      className: "o-ui-illustration-heading",
      size: "sm"
    },
    image: {
      className: "o-ui-illustration-image"
    }
  }), []));
  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-illustration", orientationValue, shape),
      ref: forwardedRef
    }),
    children: [image, heading, content]
  });
}
InnerIllustration.defaultElement = DefaultElement;
export const Illustration = slot("illustration", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerIllustration, { ...props,
  forwardedRef: ref
})));